'use strict';

import { auth } from '@/plugins/feathers-client';
import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';


const { VUE_APP_LOGIN_SSO, VUE_APP_LOGIN_CREDENTIALS, VUE_APP_ROOT_API } = process.env;

export default auth({
	userService: 'users',
	getters,
	mutations,
	actions,
	state: {
		// @enhance
		isAutologinPending: true,
		disclaimerDialogVisible: false,
		disclaimerAccepted: false,
		useLoginSSO: VUE_APP_LOGIN_SSO === 'true',
		useLoginCredentials: VUE_APP_LOGIN_CREDENTIALS === 'true',
		ssoURL: `${VUE_APP_ROOT_API}/auth/discourse`,
		authSSOError: null,
		authTokenError: null,
		authCredentialsError: null,
	},
});